import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';

const useStyles = buildUseStyles('AuthenticationFactorModalActionModify', (() => ({
  root: {},
})));

const AuthenticationFactorModalActionDefault = ({ authenticationFactorResource }) => {
  const classes = useStyles();
  const authenticationType = authenticationFactorResource.selectedOptionPrompt('authenticationType');
  const { clearModalCollection } = useModalContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return (
    <Box
      className={classes.root}
    >
      <RoundedButton
        fullWidth
        onClick={() => {
          logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, 'Auth Factor Dismiss success', {
            eventProperties: {
              authenticationType,
            },
          });
          clearModalCollection();
        }}
        test={'security-settings-button-authentication-factor-success-close'}
      >
        {'Continue'}
      </RoundedButton>
    </Box>
  );
};

AuthenticationFactorModalActionDefault.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorModalActionDefault;
